export var TYPE_IMAGE = 'picture';
export var TYPE_VIDEO = 'video';
export var TYPE_ARCHIVE = 'archive';
export var TYPE_DOCUMENT = 'document';
